import React from 'react'
import { Body, ComingSoon } from '../Resource'

export default function Inquiries() {
    return (
        <Body>
            <ComingSoon title="Inquiries" />
        </Body>
    )
}
